import {useState} from "react";
import ActivityLogsService from "../services/api/activity-logs";
import {useSnackbar} from "notistack";

const useActivityLogs = () => {

    const {enqueueSnackbar} = useSnackbar();

    const [activityLogsList, setActivityLogList] = useState([]);
    const [activityLogsDetails, setActivityLogsDetails] = useState(null);
    const [isFetchingLogDetails, setFetchingLogDetails] = useState(false);
    const [isFetchingLogList, setFetchingLogList] = useState(false);
    const [isExportActivityLogs, setExportActivityLogs] = useState(false);
    
    const listActivityLogs = (payload) => {
        setFetchingLogList(true);

        ActivityLogsService.listActivityLogs(payload).then((res) => {
            console.log("listActivityLogs data xxxx", res.data);
            
            if (res.data.success) {
                setActivityLogList(res.data.data); 
                setFetchingLogList(false);
            }

        }).catch((error) => {
            console.log("listActivityLogs error xxxx", error);
            setFetchingLogList(false);
        })
    }

    const viewActivityLogs = (activityId) => {
        setFetchingLogDetails(true);

        ActivityLogsService.viewActivityLogs(activityId).then((res) => {
            console.log("viewActivityLogs data xxxx", res.data);
            
            if (res.data.success) {
                setActivityLogsDetails(res.data.data); 
                setFetchingLogDetails(false);   
            }

        }).catch((error) => {
            console.log("viewActivityLogs error xxxx", error);

            setFetchingLogDetails(false);
        })
    }

    const exportActivityLogs = (payload) => {
        setExportActivityLogs(true);

        ActivityLogsService.exportActivityLogs(payload).then((res) => {
            console.log("exportActivityLogs data xxxx", res);
            
            if (res.data) {
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');

                a.href = url;
                a.download = `UserActivityLogs.xlsx`;
                document.body.appendChild(a);
                a.click();
                a.remove();

                let excelFilename = `UserActivityLogs.xlsx`;
                 
                enqueueSnackbar(`Successfully downloaded user activity logs, please check your downloads folder for the file: ${excelFilename}`, { 
                    variant: "success",
                    autoHideDuration: 4000
                });

                setExportActivityLogs(false);
            }

        }).catch((error) => {
            console.log("exportActivityLogs error xxxx", error);

            setExportActivityLogs(false);
        })
    }

    
    return {
        activityLogsList, activityLogsDetails, isFetchingLogDetails, isFetchingLogList, listActivityLogs, viewActivityLogs, isExportActivityLogs, exportActivityLogs
    } 
    
}

export default useActivityLogs